export const STATE_KEY = 'userDocumentsEdit'
export const FORM_NAME = 'formEditProfile'
export const INFORMATIONS_PATH_STATE_KEY = 'informationsPath'

export const CONTENT_LOAD = 'Casino/UserDocumentsEdit/CONTENT_LOAD'
export const CONTENT_LOAD_SUCCESS = 'Casino/UserDocumentsEdit/CONTENT_LOAD_SUCCESS'
export const CONTENT_LOAD_ERROR = 'Casino/UserDocumentsEdit/CONTENT_LOAD_ERROR'
